import {z} from 'zod';

import {lngLatLikeSchema} from './lngLatLikeSchema';
import {osmIdSchema} from './osmIdSchema';

export const osmSelectionStateSchema = z.object({
    type: z.literal('osm'),
    osmId: osmIdSchema,
    lngLat: lngLatLikeSchema,
    title: z.string().optional(),
    properties: z.record(z.any()),
    mapboxLayerId: z.string().optional(),
    hoverKnownRouteId: z.number().int().optional(),
});

export type OSMSelectionState = z.infer<typeof osmSelectionStateSchema>;
